<template>
  <section class="content-section container-fluid container--no-padding">
    <div class="content-section__split">
      <div class="content-section__split-half content-section__text-column">
        <div class="row">
          <div class="col-md-11 col-md-offset-1 col-lg-10 col-lg-offset-2">
            <h2>
              <contentful-text
                :item="contentfulText('homepage-2023-v01-callout-2-title')"
                :render-inline="true"
              />
            </h2>

            <contentful-text
              :item="contentfulText('homepage-2023-v01-callout-2-body')"
              :apply-markdown="true"
              class="content-section__text"
            />

            <div class="row">
              <div class="col-sm-12 content-section__cta-column content-section__cta-column--center-xs">
                <a
                  :href="contentfulText('homepage-2023-v01-callout-2-cta-1-url').Content"
                  class="btn content-section__btn content-section__btn--red-bg-white-text"
                >
                  <contentful-text
                    :item="contentfulText('homepage-2023-v01-callout-2-cta-1-label')"
                    :render-inline="true"
                  />
                </a>
                <div class="hidden-lg">
                  <br >
                </div>
                <a
                  :href="contentfulText('homepage-2023-v01-callout-2-cta-2-url').Content"
                  class="btn content-section__btn content-section__btn--white-bg-red-border"
                >
                  <contentful-text
                    :item="contentfulText('homepage-2023-v01-callout-2-cta-2-label')"
                    :render-inline="true"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        :style="imageColumnStyle"
        class="content-section__split-half content-section__image"
      />
    </div>
  </section>
</template>

<script>
export default {
  name: 'ContentSectionBravo',
  computed: {
    content () {
      return this.$store.state.pageContent
    },
    imageColumnStyle () {
      return {
        'background-image': `url(${this.contentfulImage('homepage-2023-v01-callout-2-image').Image.File.Url})`,
        'background-repeat': 'no-repeat',
        'background-position': 'center',
        'background-size': 'cover',
        'min-height': '380px'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
h2 {
  font-family: $font-barlow-condensed;
  font-size: 1.625rem;
  font-weight: 600;
  line-height: 1.875rem;
  text-transform: uppercase;

  @media screen and (min-width: $screen-sm-min) {
    font-size: 3.375rem;
    line-height: 3.375rem;
  }
}

.content-section {
  &__text {
    &-column {
      padding: 2rem;
    }

    & /deep/ p {
      font-size: 1rem;
      font-family: $font-circular-std;
      line-height: 1.6rem;
      margin-bottom: 1rem;
    }
  }

  &__cta-column {
    margin-bottom: 1rem;

    @media screen and (min-width: $screen-lg-min) {
      margin-bottom: 0;
    }

    &--center-xs {
      text-align: center;

      @media screen and (min-width: $screen-lg-min) {
        padding-left: 0;
        text-align: inherit;
      }
    }

    &--padding-left {
      padding-left: 2rem;
    }
  }

  &__btn {
    border-radius: 34px;
    font-family: $font-circular-std;
    font-weight: bold;
    text-transform: uppercase;
    padding: 0.8rem 1.4rem 0.6rem 1.4rem;
    letter-spacing: 0.01rem;
    margin-right: 0.2rem;

    &--red-bg-white-text {
      background-color: #d02a2f;
      border: 1px solid #d02a2f;
      color: #fff;
    }

    &--white-bg-red-border {
      background-color: #fff;
      border: 1px solid #d02a2f;
      color: #000;
    }
  }

  &__split {
    display: table;
    width: 100%;

    @media screen and (min-width: $screen-md-min) {
      min-height: 710px;
    }

    &-half {
      display: table;
      width: 100%;
      vertical-align: middle;

      @media screen and (min-width: $screen-md-min) {
        width: 50%;
        display: table-cell;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// WebResources/vue/grad-images/home/index/components/ContentSections/Bravo.vue